import React from 'react';
import ColorTitleDialog from '../../Dialog/ColorTitleDialog';
import { Grid } from '@material-ui/core';
import { useLang } from '../../../util/lang';
import { getWebAbsPath } from '../../../util/path';

const SmileDesignReportDialog = ({ open, handleClose }) => {
    const getLang = useLang();

    return (
        <ColorTitleDialog
            open={open}
            handleClose={handleClose}
            title={getLang('@NewPatient.prescriptionNotes.integrativeSmileDesignReportTitle')}
            showCloseBtn
            closeBtnStyle={{
                paddingLeft: 30,
                paddingRight: 30,
            }}
            actionStyle={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
            }}
        >
            <Grid container spacing={4}>
                <Grid item xs={6}>
                    <p
                        style={{ lineHeight: 1.8 }}
                        dangerouslySetInnerHTML={{
                            __html: getLang('@NewPatient.prescriptionNotes.integrativeSmileDesignReportDescription'),
                        }}
                    />
                </Grid>

                <Grid
                    item
                    xs={6}
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }}
                >
                    <img
                        src={getWebAbsPath('/img/prescriptionNotes/smile_design_integrative_report.png')}
                        alt="Integrative Smile Design Report"
                        style={{ maxWidth: '100%', maxHeight: 280 }}
                        onError={(e) => {
                            e.target.style.display = 'none';
                        }}
                    />
                </Grid>
            </Grid>
        </ColorTitleDialog>
    );
};

export default SmileDesignReportDialog;
